var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('client-only',[_c('div',[_c('div',{ref:"article",staticClass:"article",attrs:{"id":`article-${_vm.articleId}`},domProps:{"innerHTML":_vm._s(_vm.clearBody)}}),_vm._v(" "),(!_vm.isArticleFetching && !_vm.hasChannelAccess)?_c('ArticlePaywall',{attrs:{"ads-disabled":true,"article-id":_vm.articleId}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }